module.exports = __webpack_public_path__ + "img/logo.bfabb194.png";